export default __webpack_public_path__ + "static/media/ProfileImage.9c9cd271.svg";